import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import { motion } from 'framer-motion';

const ServiceCard = ({ title, description, icon: Icon, image, index }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      viewport={{ once: true }}
      style={{ height: '100%' }}
    >
      <Card
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          position: 'relative',
          '&:hover .card-image': { transform: 'scale(1.08)' },
          '&:hover .card-icon': { transform: 'translateY(-4px)' },
        }}
      >
        <Box sx={{ position: 'relative', height: 190, overflow: 'hidden' }}>
          <Box
            className="card-image"
            sx={{
              position: 'absolute',
              inset: 0,
              backgroundImage: `url(${image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              transition: 'transform 0.6s cubic-bezier(0.22,1,0.36,1)',
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background:
                'linear-gradient(180deg, rgba(8,24,58,0.15) 0%, rgba(8,24,58,0.55) 100%)',
            }}
          />
          <Box
            className="card-icon"
            sx={{
              position: 'absolute',
              left: 20,
              bottom: -28,
              width: 64,
              height: 64,
              borderRadius: 3,
              background: 'linear-gradient(135deg, #1565C0, #0D47A1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 14px 28px -12px rgba(13,71,161,0.7)',
              border: '3px solid #fff',
              transition: 'transform 0.35s ease',
            }}
          >
            <Icon sx={{ fontSize: 30, color: 'white' }} />
          </Box>
        </Box>
        <CardContent sx={{ flexGrow: 1, p: 3, pt: 4.5 }}>
          <Typography variant="h5" component="h3" sx={{ fontWeight: 700, color: 'text.primary', mb: 1.5 }}>
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.75 }}>
            {description}
          </Typography>
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default ServiceCard;
